<template>
  <form action="/">
    <Error/>
    <div class="register-container">
      <Email
        :field="getFieldByCode('email')"
        :is-required="true"
        :is-valid="this.fields.find(e => e.code === 'email').errorValid"
        text="Email"
        @change="onChangeInput"/>
      <Phone
        :field="getFieldByCode('phone')"
        :is-required="true"
        :is-valid="this.fields.find(e => e.code === 'phone').errorValid"
        text="Телефон"
        @change="onChangeInput"/>
      <Password
        :field="getFieldByCode('password')"
        :is-required="true"
        :is-valid="this.fields.find(e => e.code === 'password').errorValid"
        text="Пароль"
        @change="onChangeInput"/>
      <Password
        :field="getFieldByCode('repeatPassword')"
        :is-required="true"
        :is-valid="this.fields.find(e => e.code === 'repeatPassword').errorValid"
        text="Повторите пароль"
        placeholder="Повторите пароль"
        @change="onChangeInput"/>
      <CommonText
        :field="getFieldByCode('name')"
        text="Имя"
        placeholder="Имя"
        @change="onChangeInput"/>
      <CommonText
        :field="getFieldByCode('secondName')"
        text="Фамилия"
        placeholder="Фамилия"
        @change="onChangeInput"/>
    </div>
    <Policy v-model="isPolicy"/>
    <div class="register-container__required">
      <b>*</b> - Поля обязательные для заполнения
    </div>
    <Links
      :is-valid="isPolicy"
      @send="sendData"/>
  </form>
</template>

<script>
  import Error from './Error'
  import Email from '../Inputs/Email'
  import Phone from '../Inputs/Phone'
  import Password from '../Inputs/Password'
  import CommonText from '../Inputs/CommonText'
  import Policy from './Policy'
  import Links from './Links'
  import {mapActions} from 'vuex'

  export default {
    name: 'RegForm',
    components: {
      Error,
      Email,
      Phone,
      Password,
      CommonText,
      Policy,
      Links
    },
    data: function () {
      return {
        isPolicy: false,
        fields: [
          {
            code: 'email',
            type: 'email',
            value: '',
            errorValid: false
          },
          {
            code: 'password',
            type: 'password',
            value: '',
            errorValid: false
          },
          {
            code: 'repeatPassword',
            type: 'password',
            value: '',
            errorValid: false
          },
          {
            code: 'phone',
            type: 'phone',
            value: '',
            errorValid: false
          },
          {
            code: 'name',
            type: 'text',
            value: ''
          },
          {
            code: 'secondName',
            type: 'text',
            value: ''
          }
        ]
      }
    },
    computed: {
      isEmailValid: function () {
        const pattern = /.+@.+\..+/i
        const value = this.fields.find(e => e.code === 'email').value
        if (value.search(pattern) !== -1) {
          this.fields.find(e => e.code === 'email').errorValid = false
          return true
        } else {
          this.fields.find(e => e.code === 'email').errorValid = true
          return false
        }
      },
      isPhoneValid: function () {
        const value = this.fields.find(e => e.code === 'phone').value
        if (value.replace(/[()_ ]/g, '').length === 12) {
          this.fields.find(e => e.code === 'phone').errorValid = false
          return true
        } else {
          this.fields.find(e => e.code === 'phone').errorValid = true
          return false
        }
      },
      isPasswordValid: function () {
        const password = this.fields.find(e => e.code === 'password').value
        const repeatPassword = this.fields.find(e => e.code === 'repeatPassword').value
        if (password.length > 5) {
          if (password === repeatPassword) {
            this.fields.find(e => e.code === 'password').errorValid = false
            this.fields.find(e => e.code === 'repeatPassword').errorValid = false
            return true
          } else {
            this.fields.find(e => e.code === 'password').errorValid = false
            this.fields.find(e => e.code === 'repeatPassword').errorValid = true
            return false
          }
        } else {
          this.fields.find(e => e.code === 'password').errorValid = true
          this.fields.find(e => e.code === 'repeatPassword').errorValid = false
          return false
        }
      },
      isValid: function () {
        this.isPhoneValid
        this.isPasswordValid
        return this.isEmailValid && this.isPhoneValid && this.isPasswordValid && this.isPolicy
      }
    },
    methods: {
      ...mapActions('auth', [
        'register'
      ]),
      getFieldByCode: function (code) {
        return this.fields.find(e => e.code === code)
      },
      onChangeInput: function (entity) {
        const filed = this.getFieldByCode(entity.code)
        filed.value = entity.value
        if (filed.code === 'email') {
          this.isEmailValid
        }
        if (filed.code === 'phone') {
          this.isPhoneValid
        }
        if (filed.code === 'password') {
          this.isPasswordValid
        }
        if (filed.code === 'repeatPassword') {
          this.isPasswordValid
        }
      },
      sendData: function () {
        if (this.isValid) {
          const email = this.fields.find(e => e.code === 'email').value
          const phone = this.fields.find(e => e.code === 'phone').value
          const password = this.fields.find(e => e.code === 'password').value
          const repeatPassword = this.fields.find(e => e.code === 'repeatPassword').value
          const name = this.fields.find(e => e.code === 'name').value
          const secondName = this.fields.find(e => e.code === 'secondName').value

          this.register({
            email,
            phone,
            password,
            repeatPassword,
            name,
            secondName
          })
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Auth/Register/RegForm.vue